import type {Route} from '$lib/enums/routes';

function getParameterizedRoute(
  route: Route,
  parameters: Record<string, number | string> = {},
  dropParameters = true,
): string {
  const parts = route.split('/').map((part) => {
    const isParameter = part.startsWith(':');
    const parameterName = part.replace(':', '');
    const parameter = [[isParameter, parameterName]]
      .filter(([shouldContinue]) => Boolean(shouldContinue))
      .map(([_, name]) => name as string)
      .map((name) => parameters[name])
      .map((value) => (!value && !dropParameters ? part : value))
      .find(Boolean);
    const routePart = !isParameter ? part : undefined;

    return parameter || routePart;
  });
  const path = parts.filter(Boolean).join('/');

  return path.startsWith('/') ? path : `/${path}`;
}

function isActive(pathname: string, routes: Route[]): boolean {
  const pathParts = pathname.split('/').filter(Boolean);
  const hasMatch = routes
    .map((route) => route.split('/').filter(Boolean))
    .filter((parts) => parts.length === pathParts.length)
    .some((parts) => {
      const isMatch = parts.every((part, i) => {
        const isParam = part.startsWith(':');
        const pathValue = pathParts[i];
        const routeValue = isParam && pathValue ? pathValue : part;

        return pathValue === routeValue;
      });

      return isMatch;
    });

  return hasMatch;
}

export {getParameterizedRoute, isActive};
